export const VERSION_INFO = { tag: '2.85.2', branch: '2.85.2', commit: 'ce4f4d8433664f6e798d98b7d4883ad280210966', date: 'Tue Feb 17 11:37:15 UTC 2026' }
